<template>
  <div class="checkbox">
    <input :id="id" v-bind="$attrs" :checked="$attrs.value" type="checkbox" v-on="listeners" :disabled="disabled" />
    <label v-if="label" :for="id">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'UiCheckbox',
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: '',
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: (event) => this.$emit('input', event.target.checked),
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// stylelint-disable
.checkbox {
  @include createFlex(flexbox, nowrap, row, flex-start, center, center);

  &.label-left {
    @include createFlex(flexbox, nowrap, row-reverse, space-between, center, center);
  }

  input[type='checkbox'] {
    --active: #007aff;
    --active-inner: #fff;
    --focus: 2px rgba(39, 94, 254, 0.3);
    --border: #bbc1e1;
    --border-hover: #007aff;
    --background: #fff;
    --disabled: #f6f8ff;
    --disabled-inner: #e1e6f9;

    position: relative;
    display: inline-block;
    margin: 0;
    vertical-align: top;
    cursor: pointer;
    background: var(--b, var(--background));
    border: 1px solid var(--bc, var(--border));
    border-radius: 2px;
    outline: none;
    transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;
    -webkit-appearance: none;
    -moz-appearance: none;

    @include square(14px);
    @include flex-shrink(0);

    &::after {
      position: absolute;
      top: 2px;
      left: 4px;
      display: block;
      width: 4px;
      height: 6px;
      content: '';
      border: 2px solid var(--active-inner);
      border-top: 0;
      border-left: 0;
      opacity: var(--o, 0);
      transition: transform var(--d-t, 0.3s) var(--d-t-e, ease), opacity var(--d-o, 0.2s);
      transform: rotate(var(--r, 20deg));
    }

    &:checked {
      --o: 1;
      --r: 43deg;
      --b: var(--active);
      --bc: var(--active);
      --d-o: 0.3s;
      --d-t: 0.6s;
      --d-t-e: cubic-bezier(0.2, 0.85, 0.32, 1.2);
    }

    &:disabled {
      --b: var(--disabled);

      cursor: not-allowed;
      opacity: 0.9;
      &:checked {
        --b: var(--disabled-inner);
        --bc: var(--border);
      }
      & + label {
        cursor: not-allowed;
      }
    }

    &:hover {
      &:not(:checked) {
        &:not(:disabled) {
          --bc: var(--border-hover);
        }
      }
    }

    &:focus {
      box-shadow: 0 0 0 var(--focus);
    }

    & + label {
      display: inline-block;
      margin-left: 4px;
      font-size: 14px;
      line-height: 21px;
      vertical-align: top;
      cursor: pointer;
      width: 100%;
    }
  }
}
</style>
